export default {
  productType: null,
  plan: {
    type: null,
    name: null,
    currency: null,
    duration: null,
    link: null,
    loginPath: null,
    signupPath: null,
    price: {
      final: null,
      perMonth: null,
      original: null
    },
    freeMarkup: null,
    trialDays: null
  },
  countryCode: null,
  region: null,
  street1: null,
  street2: null,
  city: null,
  vatNumber: {
    loading: false,
    error: null,
    value: null
  },
  zip: {
    loading: false,
    error: null,
    value: null
  },
  detectedCountry: null,
  detectedRegion: null,
  tosPath: null,
  coupon: {
    loading: false,
    code: null,
    value: null,
    error: null,
    type: null,
    isSingleUse: true
  },
  selectedPaymentMethod: null,
  tax: {
    amount: null,
    region: null
  },
  email: {
    error: false,
    value: ""
  },
  giftcard: {
    recipientName: "",
    message: "",
    receiver: {
      type: "gifter",
      email: ""
    }
  },
  loading: false,
  sending: false,
  error: null,
  countryOptions: null,
  b2bTrailEnds: null,
  regionsByCountry: null,
  isIosAppPurchase: false,
  isStandalone: false,
  defaultPaymentMethod: "cc"
}
